/* ═══ ER FIX · window.on ═══════════════════════════════════════════════════
   Motion crée ses raccourcis d'événements dans theme.js :
       window.on = Element.prototype.on = theme.delegate.on
   Sur la boutique en production, `window.on` se retrouve à `null` après le
   chargement (constaté le 2026-09-14 ; aucun des 69 scripts de la page ne
   contient cette écriture — script injecté dynamiquement non identifié).
   Conséquence : les 9 appels `window.on(...)` de theme.js lèvent
   « window.on is not a function » — le menu hamburger ne s'ouvre plus,
   ainsi que le header collant, les modales et les recalculs au redimensionnement.

   Ce garde-fou restaure la fonction depuis theme.delegate, sans rien remplacer
   quand elle est déjà valide. Dernier filet : réparation au tout premier
   pointerdown, donc avant que le clic n'atteigne le gestionnaire du menu.
   Créé le 2026-09-14.
   ════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  function repare() {
    var d = window.theme && window.theme.delegate;
    if (!d) return false;
    if (typeof window.on !== 'function' && typeof d.on === 'function') window.on = d.on;
    if (typeof window.off !== 'function' && typeof d.off === 'function') window.off = d.off;
    return typeof window.on === 'function';
  }

  if (!repare()) {
    var essais = 0;
    var minuteur = setInterval(function () {
      if (repare() || ++essais > 50) clearInterval(minuteur);
    }, 100);
  }

  document.addEventListener('DOMContentLoaded', repare);
  window.addEventListener('load', repare);
  [0, 300, 1000, 2500, 5000].forEach(function (delai) { setTimeout(repare, delai); });

  /* Filet de sécurité : avant tout clic, quoi qu'il se soit passé pendant le chargement. */
  document.addEventListener('pointerdown', repare, true);
  document.addEventListener('touchstart', repare, true);
})();
